// AdsModalPage.jsx
import React from "react";
import { useParams } from "react-router-dom";

import Fee from "./Fee/Fee";
import AdsStart from "./AdsLogin/AdsStart";
import AdsLogin from "./AdsLogin/AdsLogin";
import AdsRegister from "./AdsLogin/AdsRegister";
import AdsPermission from "./AdsLogin/AdsPermission";
import AdsSupport from "./AdsLogin/components/AdsSupport"

import AdsMain from "./Ads/AdsMain";
import AdsReserve from "./Ads/components/AdsReserve"
import AdsReserveCreate from "./Ads/components/ReserveComponents/AdsReserveCreate"
import AdsReserveUpdate from "./Ads/components/ReserveComponents/AdsReserveUpdate"

import AdsAlarmList from "../assets/components/AdsAlarmList";
import AdsNotice from "./Notice/AdsNotice";
import AdsNoticeCreate from "./Notice/components/AdsNoticeCreate";
import AdsNoticeDetail from "./Notice/components/AdsNoticeDetail";
import AdsFaq from "./FAQ/Faq";
import AdsFaqCreate from "./FAQ/components/FaqCreate";

import AdsPolicy from "./policy/AdsPolicy"

import AutoMarketingPromptLoading from "./AutoMarketing/components/AutoMarketingPromptLoading";
import AutoMarketing from "./AutoMarketing/AutoMarketing";
import AutoMarketingResult from "./AutoMarketing/components/AutoMarketingResult";
import AutoMarketingRegenLoading from "./AutoMarketing/components/detailComponents/AutoMarketingRegenLoading";
import AutoMarketingUpdate from "./AutoMarketing/components/AutoMarketingUpdate";

import ManualMarketingAI from "./ManualMarketing/ManualMarketingAI/ManualMarketingAI";
import ManualMarketingAILoading from "./ManualMarketing/ManualMarketingAI/ManualMarketingAILoading";
import ManualMarketingAIResult from "./ManualMarketing/ManualMarketingAI/ManualMarketingAIResult";
import ManualMarketingAIRegen from "./ManualMarketing/ManualMarketingAI/ManualMarketingAIRegen";
import ManualMarketingFinal from "./ManualMarketing/ManualMarketingFinal";

import GalleryLoading from "./ManualMarketing/ManualMarketingGallery/GalleryLoading";
import Gallery from "./ManualMarketing/ManualMarketingGallery/Gallery"
import StoredImagePicker from "./ManualMarketing/ManualMarketingGallery/StoredImagePicker";
import GalleryResult from "./ManualMarketing/ManualMarketingGallery/GalleryResult";
import GalleryRegen from "./ManualMarketing/ManualMarketingGallery/GalleryRegen"

import EventMarketing from "./EventMarketing/EventMarketing";
import EventMarketingAI from "./EventMarketing/EventMarketingAI";
import EventMarketingAILoading from "./EventMarketing/components/EventMarketingAILoading";
import EventMarketingGallery from "./EventMarketing/components/EventMarketingGallery";

import MyPage from "./MyPage/MyPage";
import MyRecord from "./MyPage/components/MyRecord";
import MyTicket from "./MyPage/components/MyTicket";
import MyTicketNonTab from "./MyPage/components/MyTicketNonTab";
import MyTicketPurchased from "./MyPage/components/MyTicketPurchased";
import MyUsageHistory from "./MyPage/components/MyUsageHistory"
import MyPlanCancel from "./MyPage/components/MyPlanCancel"
import MyCalendar from "./MyPage/components/MyCalendar";
import MyCalendarDetail from "./MyPage/components/MyCalendarDetail";
import MyInfo from "./MyPage/components/MyInfo";
import Setting from "./MyPage/Setting";

import CancelUser from "./MyPage/components/CancelUser";
import CancelUserReason from "./MyPage/components/CancelUserReason";
import CancelUserComplete from "./MyPage/components/CancelUserComplete";
// import MyUsage from "./MyPage/components/MyUsage";

import Login from "./CMS/Admin/Login/Login"
import CMSMain from "./CMS/Main/Main";
import CmsStats from "./CMS/CmsStatistics/CmsStats"
import BusinessList from "./CMS/BusinessRegister/BusinessList";
import CmsNotice from "./CMS/CmsNotice/CmsNotice";
import CmsNoticeCreate from "./CMS/CmsNotice/CmsNoticeCreate";
import CmsNoticeDetail from "./CMS/CmsNotice/CmsNoticeDetail";
import CmsFaq from "./CMS/CmsFaq/CmsFaq";
import CmsFaqCreate from "./CMS/CmsFaq/CmsFaqCreate";
import CmsInquiry from "./CMS/CmsInquiry/CmsInquiry";
import CmsInquiryDetail from "./CMS/CmsInquiry/CmsInquiryDetail";
import CmsUsers from "./CMS/CmsUsers/CmsUsers";
import CmsUsersDetail from "./CMS/CmsUsers/CmsUsersDetail";
import CmsUsersDeleted from "./CMS/CmsUsers/CmsUsersDeleted";

// 컨시어지 영역
import ConciergeList from "./CMS/Concierge/List/ConciergeList";
import ConciergeDetail from "./CMS/Concierge/List/components/ConciergeDetail";
import ConciergeSystemList from "./CMS/Concierge/System/ConciergeSystemList";
import ConciergeHistory from "./CMS/Concierge/History/ConciergeHistory";
import ConciergeDashboard from "./CMS/Concierge/Dashboard/ConciergeDashboard";
import CaptionLab from "./CMS/Concierge/CaptionLab/CaptionLab";
import YoutubeLab from "./CMS/Concierge/YoutubeLab/YoutubeLab";
import ThreadsLab from "./CMS/Concierge/ThreadsLab/ThreadsLab";
import TestPeriod from "./CMS/Test/TestPeriod";
import ConciergeUserLogin from "./CMS/ConciergeUser/Auth/ConciergeUserLogin";
import ConciergeUserFindPin from "./CMS/ConciergeUser/Auth/ConciergeUserFindPin";
import ConciergeUserChangePin from "./CMS/ConciergeUser/Auth/ConciergeUserChangePin";
import ConciergeUserMyConcierge from "./CMS/ConciergeUser/MyConcierge/ConciergeUserMyConcierge";
import ConciergeUserHistory from "./CMS/ConciergeUser/History/ConciergeUserHistory";
import ConciergeUserPayments from "./CMS/ConciergeUser/Billing/ConciergeUserPayments";
import ConciergeUserRefunds from "./CMS/ConciergeUser/Billing/ConciergeUserRefunds";


import AdminList from "./CMS/Admin/AdminList/AdminList";
import AdminCreate from "./CMS/Admin/AdminList/AdminCreate";
import AdminDetail from "./CMS/Admin/AdminList/AdminDetail";

import Home from "./Home/Home";
import Help from "./Help/Inquiry1to1/Help"
import HelpInquiry from "./Help/Inquiry1to1/Inquiry"
import HelpFaq from "./Help/HelpFaq/HelpFaq"
import HelpNotice from "./Help/HelpNotice/HelpNotice";
import HelpNoticeDetail from "./Help/HelpNotice/HelpNoticeDetail";
import InquiryWrite from "./Support/InquiryWrite";
import InquiryHistory from "./Support/InquiryHistory"
import CallCenter from "./Support/CallCenter";

import WizMarketConcierge from "./Home/wizmarket_concierge_page";

import InternalTemplateCapturePage from "./Internal/InternalTemplateCapturePage";
import AccountDeletionRequest from "./Public/AccountDeletionRequest";

import AdsInApp from "./Ads/components/AdsInApp";
import AddressInApp from "./Ads/components/AddressInApp"

import ComponentTestView from "../assets/components/ComponentTestView";

const AdsModalPage = ({ type }) => {
  const { storeBusinessNumber, notice_no } = useParams();

  const handleClose = () => window.close();

  const ComponentMap = {
    fee: <Fee />,

    inapp: <AdsInApp onClose={handleClose} />,
    inappAddress: <AddressInApp onClose={handleClose} />,

    start: <AdsStart />,
    login: <AdsLogin isOpen={true} onClose={handleClose} storeBusinessNumber={storeBusinessNumber} />,
    permission: <AdsPermission />,

    register: <AdsRegister />,
    support: <AdsSupport />,

    main: <AdsMain />,
    reserve: <AdsReserve />,
    reserveCreate: <AdsReserveCreate />,
    reserveUpdate: <AdsReserveUpdate />,

    alarmList: <AdsAlarmList />,
    notice: <AdsNotice />,
    create: <AdsNoticeCreate />,
    edit: <AdsNoticeCreate />,
    detail: <AdsNoticeDetail notice_no={notice_no} />,

    faq: <AdsFaq />,
    faqCreate: <AdsFaqCreate />,

    inquiry: <InquiryWrite />,
    inquiryHistory: <InquiryHistory />,
    callcenter: <CallCenter />,

    policy: <AdsPolicy />,


    autoPrompt: <AutoMarketingPromptLoading />,
    auto: <AutoMarketing />,
    autoResult: <AutoMarketingResult />,
    autoRegenLoading: <AutoMarketingRegenLoading />,
    autoUpdate: <AutoMarketingUpdate />,    

    manualAI: <ManualMarketingAI />,
    manualAILoading: <ManualMarketingAILoading />,
    manualAIResult: <ManualMarketingAIResult />,
    manualAIRegen: <ManualMarketingAIRegen />,
    manualFinal: <ManualMarketingFinal />,

    cameraLoading: <GalleryLoading />,
    gallery: <Gallery />,
    storedImagePicker: <StoredImagePicker />,
    galleryResult: <GalleryResult />,
    galleryRegen: <GalleryRegen />,

    eventMarketing: <EventMarketing />,
    eventAI: <EventMarketingAI />,
    eventAILoading: <EventMarketingAILoading />,
    eventGallery: <EventMarketingGallery />,

    mypage: <MyPage />,
    myrecord: <MyRecord />,
    myticket: <MyTicket />,
    myticketNonTab: <MyTicketNonTab />,
    myticketPurchased: <MyTicketPurchased />,
    myUsageHistory: <MyUsageHistory />,
    myplanCancel: <MyPlanCancel />,
    mycalendar: <MyCalendar />,
    mycalendarDetail: <MyCalendarDetail />,
    myinfo: <MyInfo />,
    setting: <Setting />,
    cancelUser: <CancelUser />,
    cancelUserReason: <CancelUserReason />,
    cancelUserComplete: <CancelUserComplete />,
    // myusage: <MyUsage />

    adminLogin: <Login />,
    cms: <CMSMain />,
    cmsStats: <CmsStats />,
    businessList: <BusinessList />,
    cmsNotice: <CmsNotice />,
    CmsNoticeCreate: <CmsNoticeCreate />,
    CmsNoticeDetail: <CmsNoticeDetail />,
    cmsFaq: <CmsFaq />,
    cmsFaqCreate: <CmsFaqCreate />,
    cmsInquiry: <CmsInquiry />,
    cmsInquiryDetail: <CmsInquiryDetail />,
    cmsUsers: <CmsUsers />,
    cmsUsersDetail: <CmsUsersDetail />,
    cmsDeletedUsers: <CmsUsersDeleted />,
    adminList: <AdminList />,
    adminCreate: <AdminCreate />,
    adminDetail: <AdminDetail />,


    // 컨시어지 영역
    conciergeList: <ConciergeList />,
    conciergeDetail: <ConciergeDetail />,
    conciergeSystemList: <ConciergeSystemList />,
    conciergeHistory: <ConciergeHistory />,
    conciergeDashboard: <ConciergeDashboard />,
    captionLab: <CaptionLab />,
    youtubeLab: <YoutubeLab />,
    threadsLab: <ThreadsLab />,
    testPeriod: <TestPeriod />,
    conciergeUserLogin: <ConciergeUserLogin />,
    conciergeUserFindPin: <ConciergeUserFindPin />,
    conciergeUserChangePin: <ConciergeUserChangePin />,
    conciergeUserMy: <ConciergeUserMyConcierge />,
    conciergeUserHistory: <ConciergeUserHistory />,
    conciergeUserPayments: <ConciergeUserPayments />,
    conciergeUserRefunds: <ConciergeUserRefunds />,


    home: <Home />,
    help: <Help />,
    helpInquiry: <HelpInquiry />,
    helpFaq: <HelpFaq />,
    helpNotice: <HelpNotice />,
    helpNoticeDetail: <HelpNoticeDetail />,

    wizmarketConcierge: <WizMarketConcierge />,
    accountDeletionRequest: <AccountDeletionRequest />,

    internalTemplateCapture: <InternalTemplateCapturePage />,

    componentTestView: <ComponentTestView />,
  };

  return ComponentMap[type] ?? null;  // 없으면 null 반환
};

export default AdsModalPage;
